import httpClient from '../httpClient';

export const startTrackingSession = async ({
  sessionId,
  idCustomer,
  landingPage,
  referrer,
}) => {
  const result = await httpClient.post('/tracking/session/start', {
    sessionId,
    idCustomer,
    landingPage,
    referrer,
  });
  return result.data;
};

export const sendTrackingHeartbeat = async (sessionId) => {
  const result = await httpClient.post('/tracking/session/heartbeat', {
    sessionId,
  });
  return result.data;
};

export const endTrackingSession = async (sessionId) => {
  const result = await httpClient.post('/tracking/session/end', {
    sessionId,
  });
  return result.data;
};

export const logTrackingPageView = async (pageView) => {
  const result = await httpClient.post('/tracking/page-view', pageView);
  return result.data;
};

export const logTrackingEvent = async (event) => {
  const result = await httpClient.post('/tracking/event', event);
  return result.data;
};
